import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { catchError, of } from "rxjs";
import { ClientLog } from "./client-log";

@Injectable({
    providedIn: "root"
})
export class ClientLogService extends BaseDataService {
    url = "api/client-log";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    save(errorLog: ClientLog): Promise<any> {
        return this.handleRequest(this.http.post(`${this.url}`, errorLog).pipe(catchError(_ => of())));
    }
}
